export const Breakpoints = {
  xxsmall: "374px",
  xsmall: "435px",
  small: "576px",
  medium: "768px",
  large: "992px",
  xlarge: "1200px",
};
